import { encodeData } from "~/utils/utils";
import LegacyApiService from "./LegacyApiService";

class ConfigOptionsService {
  getAllByQuery(...options) {
    const query = encodeData({ names: options.join(`,`) });
    return LegacyApiService.get(`/config-options?${query}`);
  }
}

export default new ConfigOptionsService();
